/**
 * Quick-add behavior for the "Leve junto" carousel inside the cart drawer.
 *
 * This is loaded as a static module script from the drawer's outer (non-morphed)
 * markup — see snippets/cart-drawer.liquid — specifically so it survives the
 * theme's Section Rendering API + DOM-morph cycle that re-renders the drawer's
 * inner content (items / free-shipping bar / this carousel) on every cart
 * change. An inline <script> placed *inside* that re-rendered content would be
 * parsed from the fetched HTML and appended via morph, and browsers never
 * execute a <script> element that was inserted that way — so the buttons would
 * render but never respond to clicks. Binding the click listener here, once, on
 * `document`, sidesteps that entirely: event delegation means it keeps working
 * no matter how many times the carousel's markup underneath gets replaced.
 */

function leveJuntoScrollByCard(track, direction) {
  var card = track.querySelector('.cart-leve-junto__item');
  var amount = card ? card.getBoundingClientRect().width + 10 : 160;
  track.scrollBy({ left: amount * direction, behavior: 'smooth' });
}

function leveJuntoAdd(button) {
  var variantId = button.getAttribute('data-variant-id');
  if (!variantId || button.disabled) return;

  button.disabled = true;
  button.classList.add('is-loading');

  var hasStandardActions =
    window.Shopify && window.Shopify.actions && typeof window.Shopify.actions.updateCart === 'function';

  var addPromise;
  if (hasStandardActions) {
    addPromise = window.Shopify.actions
      .updateCart(
        { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }] },
        { event: { context: 'dialog', detail: { source: 'cart-leve-junto' } } }
      )
      .then(function (result) {
        var userErrors = result && result.userErrors;
        if (userErrors && userErrors.length) {
          return Promise.reject(new Error(userErrors.map(function (e) { return e.message; }).join(', ')));
        }
        return result;
      });
  } else {
    addPromise = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          return Promise.reject(new Error((data && (data.description || data.message)) || 'Falha ao adicionar ao carrinho.'));
        });
      }
      return response.json();
    });
  }

  addPromise
    .then(function () {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      setTimeout(function () {
        button.classList.remove('is-added');
        button.disabled = false;
      }, 1500);
      // The theme's own cart-drawer listens for this standard update and
      // re-renders the drawer section, which redraws this carousel (removing
      // the item just added) and the free-shipping bar automatically.
    })
    .catch(function () {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      setTimeout(function () {
        button.classList.remove('is-error');
      }, 1500);
    });
}

document.addEventListener('click', function (event) {
  var addButton = event.target.closest('[data-leve-junto-add]');
  if (addButton) {
    event.preventDefault();
    leveJuntoAdd(addButton);
    return;
  }

  var prevButton = event.target.closest('[data-leve-junto-prev]');
  if (prevButton) {
    var prevTrack = prevButton.closest('.cart-leve-junto__viewport').querySelector('[data-leve-junto-track]');
    if (prevTrack) leveJuntoScrollByCard(prevTrack, -1);
    return;
  }

  var nextButton = event.target.closest('[data-leve-junto-next]');
  if (nextButton) {
    var nextTrack = nextButton.closest('.cart-leve-junto__viewport').querySelector('[data-leve-junto-track]');
    if (nextTrack) leveJuntoScrollByCard(nextTrack, 1);
  }
});
